import {createAction, createSlice} from '@reduxjs/toolkit';
import {NotificationManager} from '../components/common/react-notifications';
import {defaultColor, messageDismissTime} from '../constants/defaultValues';
import {removeCurrentUser, setCurrentColor} from '../helpers/Utils';

export const sessionStates = {
  ACTIVE: 'ACTIVE', // User is logged in
  EXPIRED_SESSION: 'EXPIRED_SESSION', // User's session has expired and needs to be logged out
  LOGGING_OUT: 'LOGGING_OUT', // User has clicked log out
  INACTIVE: 'INACTIVE', // User is logged out
};

const initialState = {
  lastViewedSite: null,
  lastViewedStation: null,
  sessionState: sessionStates.INACTIVE,
};

export const resetSlicesToInitialState = createAction('resetSlicesToInitialState');

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLastViewedSite: (state, {payload}) => {
      state.lastViewedSite = payload;
    },
    setLastViewedStation: (state, {payload}) => {
      state.lastViewedStation = payload;
    },
    setSessionHasStarted: state => {
      state.sessionState = sessionStates.ACTIVE;
    },
    setSessionHasExpired: state => {
      state.sessionState = sessionStates.EXPIRED_SESSION;
    },
    setSessionIsLoggingOut: state => {
      state.sessionState = sessionStates.LOGGING_OUT;
    },
    setSessionHasEnded: state => {
      state.sessionState = sessionStates.INACTIVE;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetSlicesToInitialState, () => initialState);
  },
});

export const {
  setLastViewedSite,
  setLastViewedStation,
  setSessionHasStarted,
  setSessionHasExpired,
  setSessionIsLoggingOut,
  setSessionHasEnded,
} = slice.actions;

export const selectLastViewedSiteOrStation = state => {
  if (state.user.lastViewedStation) return {stationId: state.user.lastViewedStation};
  if (state.user.lastViewedSite) return {siteId: state.user.lastViewedSite};
  return null;
};

export default slice.reducer;
